import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICreditMultiplierResponse, IPackageList } from "api/payment/payment.type";

interface CreditState {
  creditMultiplier: ICreditMultiplierResponse | null;
  packageList: IPackageList | null;
}

const initialState: CreditState = {
  creditMultiplier: null,
  packageList: null,
};

export const creditSlice = createSlice({
  name: "credit",
  initialState,
  reducers: {
    setCreditMultiplier: (state, action: PayloadAction<ICreditMultiplierResponse>) => {
      state.creditMultiplier = action.payload;
    },
    setPackageList: (state, action: PayloadAction<IPackageList>) => {
      state.packageList = action.payload;
    },
  },
});

export const { setCreditMultiplier, setPackageList } = creditSlice.actions;

export default creditSlice.reducer;
